import styled from '@emotion/styled';
import PropTypes from 'prop-types';

// Assets
import IconCheck from '../icons/icon-check';

// Styled Components
const Container = styled.div`
  display: flex;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '40px')};
  overflow-x: scroll;
  position: relative;
  width: 100%;
`;

const Step = styled.div`
  align-items: center;
  border-bottom: ${props => (props.completed || props.current ? '2px' : '1px')}
    solid;
  border-color: ${props =>
    props.completed || props.current ? '#D40F7D' : '#6D6D6D'};
  color: ${props =>
    props.current ? '#000000' : props.completed ? '#D40F7D' : '#6D6D6D'};
  display: inline-flex;
  flex-shrink: 0;
  font-size: 15px;
  padding: 8px;
  padding-bottom: ${props => !props.completed && !props.current && '9px'};
  position: relative;
  text-transform: uppercase;

  ${props =>
    props.fullPage &&
    `
    flex-grow: 1;
    justify-content: center;

  `}

  &:last-of-type {
    flex-grow: 1;
  }

  &:before {
    background-color: ${props =>
      props.completed || props.current ? '#D40F7D' : '#6D6D6D'};
    border-radius: 100%;
    color: #ffffff;
    content: ${props => (props.completed ? `""` : `"${props.number}"`)};
    display: inline-block;
    font-size: 12px;
    height: 16px;
    line-height: 16px;
    margin-right: 8px;
    position: relative;
    text-align: center;
    width: 16px;
  }
`;

const Check = styled(IconCheck)`
  display: inline-block;
  fill: #ffffff;
  height: 6px;
  left: ${props => (props.fullPage ? '84px' : '12px')};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
`;

const FormProgress = ({
  pages,
  currentPage,
  marginBottom = null,
  fullPage = false,
}) => (
  <Container marginBottom={marginBottom}>
    {pages.map((page, index) => {
      const completed = index < currentPage;
      const current = index == currentPage;
      const pageNumber = index + 1;

      return (
        <Step
          completed={completed}
          current={current}
          key={index}
          number={pageNumber}
          fullPage={fullPage}
        >
          {completed && <Check fullPage={fullPage} />}
          {page.progressLabel || page.title}
        </Step>
      );
    })}
  </Container>
);

export default FormProgress;

FormProgress.propTypes = {
  pages: PropTypes.array,
  currentPage: PropTypes.number,
  marginBottom: PropTypes.string,
  fullPage: PropTypes.fullPage,
};
